import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

export const activate = async (token, password, confirmPassword) => {
    try {
        const response = await axios.post(`${API_URL}/users/activate`, {token, password, confirmPassword});
        return response.data;
    } catch (error) {
        throw new Error('Error: Could not register.');
    }
};

export const login = async (username, password) => {
    try {
        const response = await axios.post(`${API_URL}/auth/login`, {username, password});

        const token = response.data.token;
        const _username = response.data.username;
        const role = response.data.role;
        const isPublishModeActive = response.data.isPublishModeActive;

        const data = {token, _username, role}

        if (token) {
            localStorage.setItem('user', JSON.stringify(
                {
                    token, _username, role, language: "en", isPublishModeActive
                }
            ));
        } else {
            console.log('Error: No token returned.');
        }

        return {data};
    } catch (error) {
        throw new Error('Error: Invalid credentials.');
    }
};

export const logout = () => {
    localStorage.removeItem('user');
};

export const getCurrentUser = () => {
    return JSON.parse(localStorage.getItem('user'));
};

export const updateUserLanguage = async (language) => {
    const currentUser = JSON.parse(localStorage.getItem('user')) || {};
    currentUser.language = language;
    localStorage.setItem('user', JSON.stringify(currentUser));
};
